import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Modal } from 'react-bootstrap';


class DayViewModal extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    // LIFECYCLE METHODS

    // EVENT HANDLERS

    handleClose = () => {
        this.props.handleClose();
    }

    // OTHER METHODS

    dateToInt = (date) => {
        let dateArr = date.split("-");
        let dateStr = dateArr[0] + dateArr[1] + dateArr[2];
        return parseInt(dateStr);
    }

    // RENDER METHOD

    render = () => {
        let lenList = this.props.logEntriesByTimesheet;

        let logEntriesByDate = [];
        let dates = [];

        lenList.map(len => {
            let dateInt = this.dateToInt(len.date);

            if(!dates.includes(dateInt))
                dates.push(dateInt);
        });
        
        dates.map(date => {
            logEntriesByDate[date] = [];
        });

        for (let i = 0; i < this.props.logEntriesByTimesheet.length; i++) {
            let logEntry = this.props.logEntriesByTimesheet[i];
            if (logEntry.taskName !== this.props.task.name || logEntry.projectName !== this.props.projectName) {
                continue;
            }

            let dateInt = this.dateToInt(logEntry.date);
            logEntriesByDate[dateInt].push(logEntry);
        }

        dates.sort();

        return (
            <Modal show={true} onRequestHide={this.handleClose} className="modal fade" id="myModal3" tabIndex="-1" role="dialog" aria-labelledby="myModal3Label" aria-hidden="true">
                <div className="popover1 modal-dialog new-log-entry">
                    <div className="modal-content">
                        <form>
                            <div style={{backgroundColor : this.props.color}} className="head modal-header">
                                <button style={{marginTop : "-20px", marginRight : "-5px"}} onClick={this.handleClose} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                                <h4 style={{"color" : "white", backgroundColor : this.props.color}}>{this.props.projectName}</h4>
                                <h4 style={{"color" : "white", backgroundColor : this.props.color}}>{this.props.task.name}</h4>
                            </div>
                            <div className="scrollable-div content modal-body">
                                <h4>{this.props.usersName}</h4>
                                {
                                    dates.filter(date => {
                                        if(logEntriesByDate[date].length === 0) {
                                            return false;
                                        }
                                        return true;
                                    }).map((date, key) => {
                                        let logEntries = logEntriesByDate[date];
                                        let dayTotal = 0;
                                        for (let i in logEntries) {
                                            dayTotal = dayTotal + parseInt(logEntries[i].duration);
                                        }
                                        let dayTotalHours = Math.trunc(dayTotal / 60);
                                        let dayTotalMinutes = parseFloat((dayTotal % 60).toFixed(0));

                                        return (
                                            <span key={key}>
                                                <h5>
                                                    {moment(date, "YYYY-MM-DD").format("dddd DD.MM.YYYY.")}
                                                    <span style={{float: "right"}}>
                                                        = {dayTotalHours + "h"}
                                                        {dayTotalMinutes > 0 ? " " + dayTotalMinutes + "min" : ""}
                                                    </span>
                                                </h5>
                                                {
                                                    logEntries.map((logEntry, logEntryKey) => {
                                                        let usersName = logEntry.lastModifiedByUser.substring(0, logEntry.lastModifiedByUser.indexOf(" ("));
                                                        let hours = Math.trunc(logEntry.duration / 60);
                                                        let minutes = parseFloat((logEntry.duration % 60).toFixed(0));
                                                        return (
                                                            <span key={logEntryKey}>
                                                                <h6 className="clearfix" style={logEntry.overtime ? {"color" : "red"} : {}}>{hours + "h"}{minutes > 0 ? " " + minutes + "min" : ""}
                                                                {
                                                                    this.props.usersName != usersName
                                                                    ? <div className="pull-right" style={{ "font-weight": "normal" }}>Last modified by: { usersName }</div>
                                                                    : null
                                                                }
                                                                </h6>
                                                                <p>{logEntry.description}</p>
                                                            </span>
                                                        );
                                                    })
                                                }
                                            </span>
                                        );
                                    })
                                }
                            </div>
                            <div className="modal-footer">
                                <button title="Close task details by days" type="button" className="btn btn-default btn-large" onClick={this.handleClose}>Close</button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
        );
    }
}

DayViewModal.propTypes = {
    color: PropTypes.string,
    handleClose: PropTypes.func,
    logEntriesByTimesheet: PropTypes.array,
    projectName: PropTypes.string,
    task: PropTypes.object,
    usersName: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        logEntriesByTimesheet: state.logEntries.logEntriesByTimesheet
    };
};

export default connect(
    mapStateToProps
)(DayViewModal);


/** WEBPACK FOOTER **
 ** ./src/app/components/DayViewModal.js
 **/